<template>
  <div class="bottom">
    <el-row :gutter="20">
      <div class="desktop-layout">
        <el-col :xs="0" :sm="0" :md="0" :lg="6" :xl="6">
        <div>
          <el-image class="bottom-logo" :fit="'fill'" :src="logoUrl" alt="logo" />
        </div>
      </el-col>
      </div>
      <el-col :xs="16" :sm="16" :md="16" :lg="12" :xl="12">
        <h3 style="white-space: pre-line">{{claim[0]}}</h3>
        <p class="bottom-contact">
          phone: +1(604)761-9732<br/>
          email: john@timelyelectric.ca<br/>
          WhatsApp: 16047619732<br/>
          Wechat: e123e123e<br/>
          {{claim[1]}}<br>
          <!-- {{claim[2]}} -->
        </p>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="6">
        <h4>{{claim[3]}}</h4>
        <div>
          <el-image class="bottom-payment" :src="urlInterac" fit="fill" /> 
          <el-image class="bottom-payment" :src="urlMaster" fit="fill" /> 
          <el-image class="bottom-payment" :src="urlVisa" fit="fill" />
        </div>
        <p class="bottom-terms">
          <a href="/policy/terms-of-service.html">{{claim[4]}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
          <a href="/policy/privacy-policy.html">{{claim[5]}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
        </p>
      </el-col>
    </el-row>
    <el-divider />
    <div class="bottom-claim">
      <p>
        Copyright©2024-{{thisYear}} Timely Construction Ltd.&nbsp;&nbsp;&nbsp;&nbsp;Powered by
      </p>
      <a href="https://fairycow.ca" alt="Developed by FairyCOW" target="_blank"
        style="display: inline-flex; align-items: center; text-decoration: none; color: inherit;">
        <el-image style="width: 20px; height: 20px; margin-right: 4px;" :fit="'fill'" :src="fairycowUrl" alt="fairycow-logo" />
        FairyCOW
      </a>
    </div>
  </div>
</template>


<script>
import { Store } from '@/utils/store'
import { Lang } from '@/utils/language'
export default {
  name: 'BottomClaim',
  props: {
    logo: {
      reuired: true,
      type: String
    }
  },
  data() {
    return {
      urlInterac: require('@/assets/payment/interac.png'),
      urlMaster: require('@/assets/payment/master.png'),
      urlVisa: require('@/assets/payment/visa.png'),
      fairycowUrl: require('@/assets/fairycow-logo.png'),
      logoUrl: this.logo,
      thisYear: Store.thisYear,
    }
  },
  computed: {
    claim() {
      if (Store.lang == 'en') {
        return Lang.Claim.en;
      } else {
        return Lang.Claim.cn;
      }
    },
  },  
}
</script>


<style lang="scss" scoped>
@import '@/assets/variables.scss';
h3 {
  color: #fff;
}
a {  
  text-decoration: none;
  color: rgba(255,255,255,0.7);
}
.bottom {
  z-index: 1;
  width: auto;
  min-height: $bottom-height;
  background-color: $neutral-800;
  color: rgba(255,255,255,0.7);
  font-family: Poppins;
  font-size: 1em;
  text-align: left;
}
.bottom-logo {
  margin-top: 20px;
  width:128px; 
  height:128px;
}
.bottom-claim {
  font-size: 0.85em;
  text-align: center;
}
/* 设置了浏览器宽度不小于1201px时 list显示的宽度 */
@media screen and (min-width: 1080px) {
  .desktop-layout {
    display: block;
  }
  .mobile-layout {
    display: none;
  }
  .bottom {
    padding: 20px 10%;
  }
  .bottom-contact, .bottom-terms {
    font-size: 1em;
  }
  .bottom-payment {
    padding: 0 5px;
    width:80px; 
  }  
}
@media screen and (max-width: 1080px) and (orientation: portrait) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }  
  .bottom {
    padding: 0px 5% 10px 5%;
  }
  .bottom-contact, .bottom-terms {
    font-size: 0.6em;
  }
  .bottom-payment {
    padding: 0 3px;
    height: 13px; 
  }  
}
</style>